module.exports = __webpack_public_path__ + "img/ic_org_chart_24px@2x.d1662c86.png";